<template>
  <section
    v-if="product?.productSets?.length"
    :aria-label="$t.shopTheLookHeading"
    :class="{ 'col-span-12': product?.productSets?.length! === 1 }"
    data-scroll-el="shopTheLook"
  >
    <div v-if="product.productSets.length === 1" class="relative grid gap-1 lg:cols-4 lg:rows-1">
      <base-button class="relative full lg:col-span-2" @click="openShopTheLook(product.productSets[0])">
        <base-picture
          :alt="product.productSets[0].description"
          class="h-a w-full object-cover"
          :height="gallery.presets.src.height"
          :src="getImageTransformations(product.productSets[0].images[0], gallery.presets.src)"
          :width="gallery.presets.src.width"
        />
        <span class="absolute left-2 top-1 z-1 m-2 rounded-xs underscored body-4">
          {{ product.productSets[0].text || $t.shopTheLookTileCta }}
        </span>
      </base-button>
      <div class="flex gap-1 overflow-x-auto lg:grid lg:col-span-2 lg:cols-2 lg:gap-1">
        <div
          v-for="{ id, thumbnail } in product.productSets[0].products?.slice(0, productSetImageThreshold)"
          :key="id"
          v-style:w="{
            sm: (product.productSets[0].products?.slice(0, productSetImageThreshold)?.length ?? 0) > 2 ? '42%' : '50%',
            lg: '100%',
          }"
          class="relative <lg:flex-shrink-0"
        >
          <base-button @click="PanelQuickshop.open({ productId: id })">
            <vf-icon class="absolute right-0 top-0 m-2" :name="quickshopIcon" size="md" />
            <base-picture
              :alt="product.productSets[0].description"
              class="h-a w-full object-cover"
              :height="gallery.presets.src.height"
              :src="getImageTransformations(thumbnail, gallery.presets.src)"
              :width="gallery.presets.src.width"
            />
          </base-button>
        </div>
      </div>
    </div>
    <vf-carousel-elevate
      v-else
      class-controls="<lg:hidden h-10 w-10 bg-brand-1/50 p-2 c-white shadow-sm @hactive:bg-brand-1/90"
      :show-arrows="false"
      size-controls="md"
    >
      <div
        v-for="productSet in product.productSets"
        :key="productSet.productSetId"
        v-style:w="{
          sm: '85%',
          lg: product.productSets.length >= 3 ? '40%' : `${100 / product.productSets.length}%`,
        }"
        class="relative"
      >
        <base-button class="relative full" @click="openShopTheLook(productSet)">
          <base-picture
            :alt="productSet.description"
            class="h-a w-full object-cover"
            :height="gallery.presets.src.height"
            :src="getImageTransformations(productSet.images[0], gallery.presets.src)"
            :width="gallery.presets.src.width"
          />
          <span class="absolute left-2 top-1 z-1 m-2 rounded-xs underscored body-4">
            {{ productSet.text || $t.shopTheLookTileCta }}
          </span>
        </base-button>
      </div>
    </vf-carousel-elevate>
    <panel-quickshop class-content="lg:|w-100" />
  </section>
</template>

<script setup lang="ts">
const {
  gallery,
  shopTheLook: {
    productSetImageThreshold = 4,
    quickshopIcon = 'quickshop'
  } = {}
} = useAppConfig().pages?.pdp || {}

const { openShopTheLook, product } = usePdp()
const PanelQuickshop = createPanel('quickshop-elevate')
</script>
